module.exports = __webpack_public_path__ + "img/1.6cee83c1.webp";